import { css, FlattenInterpolation, ThemeProps, Theme } from 'styled-components';
import { zIndex } from '.';

export const backgroundStyles = ({ $rtl }: { $rtl: boolean }): FlattenInterpolation<ThemeProps<Theme>> | null =>
  $rtl
    ? css`
        position: relative;
        ::before {
          position: absolute;
          z-index: ${zIndex('behindContent')};
          width: 100%;
          height: 100%;
          transform: scaleX(-1);
          content: '';
        }
      `
    : null;

export const backgroundImage = (backgroundImage?: string) => ({
  $rtl,
  $backgroundImageUrl,
}: {
  $rtl: boolean;
  $backgroundImageUrl?: string | null;
}): FlattenInterpolation<ThemeProps<Theme>> | undefined => {
  if (backgroundImage || $backgroundImageUrl) {
    return $rtl
      ? css`
          ::before {
            background-image: url(${backgroundImage || $backgroundImageUrl});
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
          }
        `
      : css`
          background-image: url(${backgroundImage || $backgroundImageUrl});
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        `;
  }
};
